/**
 * Number based feature flags.
 *
 * Insert new flags alphabetically inside the keep-sorted block, with a date and a description.
 *
 * https://docs.launchdarkly.com/home/getting-started/feature-flags
 */

export const NUMBER_FEATURE_FLAGS = [
  // keep-sorted:begin
  // (cam) - Max number of days for custom metrics
  'org_metrics_max_timerange_in_days',

  // 2026-07-29 (cam) - Max concurrent suggested-times queries per client; 0 or unset = unlimited
  'org_suggested_times_fetch_concurrency',

  'org_sync_job_stage_and_application_timeout_ms',

  'user_interview_plan_auto_save_debounce_timeout',

  'user_task_polling_seconds',
  // keep-sorted:end
] as const;

export type FeatureFlagNumber = (typeof NUMBER_FEATURE_FLAGS)[number];
